<mat-dialog-header>
    <h2 [id]="identifierService.labelId('viewleadsDialog', 'patientLeadData')" mat-dialog-title data-tx-key="label.gb.patient_lead_data" class="dialogTitle">{{ 'label.gb.patient_lead_data' | translate }}</h2>
    <!-- <button mat-button mat-dialog-close class ="closeIcon">X</button> -->
</mat-dialog-header>
<mat-dialog-content class="mat-typography-content">
    <div>
        <label [id]="identifierService.labelId('viewleadsDialog', 'patientname')" for="" class="labelText" data-tx-key="label.gb.patientname">{{ 'label.gb.patientname' | translate }} :</label
        >&nbsp;
        <label [id]="identifierService.labelId('viewleadsDialog', 'patientNameValue')" for="" class="infoText"
            >{{patientName.join(', ')}}</label
        >
    </div>
    <div>
        <label for="" [id]="identifierService.labelId('viewleads-dialog', 'devModel')" class="labelText" data-tx-key="label.gb.dev_model" [innerHtml]="translate('label.gb.dev_model')"></label
        > :&nbsp;
        <label [id]="identifierService.labelId('viewleadsDialog', 'deviceModelValue')" for="" class="infoText"
            >{{
                patientDevice?.modelNum
                    ? patientDevice?.modelNum
                    : getDeviceName()
            }}
        </label>
    </div>
    <div>
        <label for="" [id]="identifierService.labelId('viewleads-dialog', 'devSerial')" class="labelText" data-tx-key="label.gb.dev_serial" [innerHtml]="translate('label.gb.dev_serial')"></label
        > :&nbsp;
        <label [id]="identifierService.labelId('viewleadsDialog', 'serialNumValue')" for="" class="infoText">{{
            patientDevice?.serialNum
        }}</label>
    </div>
    <div>
        <label for="" [id]="identifierService.labelId('viewleads-dialog', 'implantDate')" class="labelText" data-tx-key="label.gb.implant_date" [innerHtml]="translate('label.gb.implant_date')"> :</label
        > :&nbsp;
        <label [id]="identifierService.labelId('viewleadsDialog', 'implantDateValue')" for="" class="infoText">{{
            patientDevice?.implantDate
        }}</label>
    </div>
    <div class="row">
        <div class="col-xs-12">
            <merlin-section [sectionPadding]="false">
                <div class="merlin-dataTable">
                    <table mat-table matSort [dataSource]="leadsDatasource" [id]="
                            identifierService.dropdownId(
                                'view-leads-dialog',
                                'table'
                            )
                        ">
                        <ng-container matColumnDef="location">
                            <th [id]="identifierService.labelId('viewleadsDialog', 'thType')" mat-header-cell *matHeaderCellDef mat-sort-header data-tx-key="label.gb.type">
                                {{ 'label.gb.type' | translate }}
                            </th>
                            <td [id]="identifierService.labelId('viewleadsDialog', 'tdTypeVal')" mat-cell *matCellDef="let element">
                                {{ getLocation(element) ? getLocation(element) : '---' }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="manufacturer">
                            <th [id]="identifierService.labelId('viewleadsDialog', 'thManufacturer')" mat-header-cell *matHeaderCellDef mat-sort-header data-tx-key="label.gb.manufacturer">
                                {{ 'label.gb.manufacturer' | translate }}
                            </th>
                            <td [id]="identifierService.labelId('viewleadsDialog', 'tdMfgVal')" mat-cell *matCellDef="let element">
                                {{ element.manufacturer ? element.manufacturer : '---' }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="modelNum">
                            <th [id]="identifierService.labelId('viewleadsDialog', 'thModel')" mat-header-cell *matHeaderCellDef mat-sort-header data-tx-key="label.gb.model">
                                {{ 'label.gb.model' | translate }}
                            </th>
                            <td [id]="identifierService.labelId('viewleadsDialog', 'tdModelVal')" mat-cell *matCellDef="let element">
                                {{ element.modelNum ? element.modelNum : '---' }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="serialNum">
                            <th [id]="identifierService.labelId('viewleadsDialog', 'thSerialNumber')" mat-header-cell *matHeaderCellDef mat-sort-header data-tx-key="label.gb.serial_number">
                                {{ 'label.gb.serial_number' | translate }}
                            </th>
                            <td [id]="identifierService.labelId('viewleadsDialog', 'tdSerialVal')" mat-cell *matCellDef="let element">
                                {{ element.serialNum ? element.serialNum : '---' }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="length">
                            <th [id]="identifierService.labelId('viewleadsDialog', 'thLength')" mat-header-cell *matHeaderCellDef mat-sort-header data-tx-key="label.gb.length">
                                {{ 'label.gb.length' | translate }}
                            </th>
                            <td [id]="identifierService.labelId('viewleadsDialog', 'tdLenVal')" mat-cell *matCellDef="let element">
                                {{ element.length ? element.length : '---' }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="implantDate">
                            <th [id]="identifierService.labelId('viewleadsDialog', 'thImplantDate')" mat-header-cell *matHeaderCellDef mat-sort-header data-tx-key="label.gb.implant_date" [innerHtml]="translate('label.gb.implant_date')">
                            </th>
                            <td [id]="identifierService.labelId('viewleadsDialog', 'tdImplantVal')" mat-cell *matCellDef="let element">
                                {{ element.implantDate ? element.implantDate : '---' }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="noData">
                            <td mat-cell *matFooterCellDef [attr.colspan]="displayedColumns?.length" [id]="
                                    identifierService.labelId(
                                        'view-leads-dialog',
                                        'no-record'
                                    )
                                " class="no-record">
                                <p class="noRecord">No records found.</p>
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                    </table>
                </div>
            </merlin-section>
        </div>
        <div class="col-xs-12">
            <div>
                <p [id]="identifierService.labelId('viewleadsDialog', 'footerText')" class="cardText">
                    {{ getViewLeadsFooterText('msg.pa056.text') }}
                </p>
            </div>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button mat-dialog-close color="accent" [id]="identifierService.dropdownId('viewleads-dialog', 'close')" data-tx-key="label.gb.close">
        {{ 'label.gb.close' | translate }}
    </button>
</mat-dialog-actions>
